<div class="page-container">
  <ion-list lines="none">
    <ion-item *ngFor="let member of lstServants" lines="full">
      <ion-avatar slot="start">
        <img *ngIf="member.ImageSrc" alt="Servant" class="largerImage" [src]="member.ImageSrc">
        <img *ngIf="!member.ImageSrc" alt="Servants" class="largerImage" src="assets/images/default.png">
      </ion-avatar>
      <ion-label>
        <b>{{member.ProfileName}}</b><br>
        {{member.ServiceName}}<br>
        <span class="space-between">
          <a href="tel:{{member.Mobile1}}">{{member.Mobile1}}</a>
          
          <a [attr.href]="'sms:'+ member.Mobile1 | safeUrl">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon></a>
        </span>
        <a href="mailto:{{member.PrimaryEmail}}">{{member.PrimaryEmail}}</a>
      </ion-label>
    </ion-item>
  </ion-list>
</div>